import React from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import { FormInput, FormLabel, Label, ErrorText, ResponsiveBlock } from '@styled';

const TributeInfo = ({ tributeType, tributeName, onTributeTypeChange, onTributeNameChange }) => (
    <fieldset className="mt-1">
        <Label className="mb-3 mb-md-2">
            <FormLabel>Select Tribute Type</FormLabel>

            <select name="tributeType" value={tributeType} style={{ width: '250px' }} onChange={onTributeTypeChange}>
                <option value="">Select...</option>
                <option value="honorarium">In Honor of</option>
                <option value="memoriam">In Memory of</option>
            </select>

            <ResponsiveBlock className="mt-1 mt-md-0">
                <ErrorText className="legend-error">
                    <ErrorMessage name="tributeType" />
                </ErrorText>
            </ResponsiveBlock>
        </Label>
        <br />

        <Label className="mb-3 mb-md-2" htmlFor="tributaryID">
            <FormLabel>Tribute Name</FormLabel>
            <FormInput
                name="tributary"
                id="tributaryID"
                type="text"
                label="Tribute Name"
                value={tributeName}
                onChange={onTributeNameChange}
            />

            <ResponsiveBlock className="mt-1 mt-md-0">
                <ErrorText className="legend-error">
                    <ErrorMessage name="tributary" />
                </ErrorText>
            </ResponsiveBlock>
        </Label>
    </fieldset>
);

TributeInfo.propTypes = {
    tributeType: PropTypes.string.isRequired,
    tributeName: PropTypes.string.isRequired,
    onTributeTypeChange: PropTypes.func.isRequired,
    onTributeNameChange: PropTypes.func.isRequired,
};

export default TributeInfo;
